import { 
  Routes,
  Route,
  Navigate,
  useLocation,
  Outlet,
} from "react-router-dom";
import {
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from "react-query";
import { toast, ToastContainer } from "react-toastify";
import { ReactQueryDevtools } from 'react-query/devtools'
import PageAsModal from "./hoc/PageAsModal";
import { Layouts } from "./components";
import { PortalizedModalProvider } from "./components/PortalizedModal";
import * as Pages from "./pages"
import { SessionProvider } from "./contexts/SessionContext";
import { CompanyContextProvider } from "./contexts/CompanyContext";
import "./App.scss";


export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      toast.error(`Something went wrong: ${error.message}`)
      console.debug(`ReactQueryError::`, error);
    }
  }),
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: true,
      stalecompaniese: Infinity,
      useErrorBoundary: true,
    },
  },
})

function App() {
  const location = useLocation();
  const { state } = location;
  console.debug('state', state, state?.backgroundLocation);
  return (
    <QueryClientProvider client={queryClient}>
      <PortalizedModalProvider>
      <SessionProvider>
      <Routes location={state?.backgroundLocation || location}>
        <Route path="/" element={ <Layouts.AppLayout /> }>
          <Route index element={ <Navigate to="companies" replace /> } />
          <Route path="companies" element={ <Outlet /> }>
            <Route path=":company_id" element={ <Pages.CompanyView /> } />
            <Route path=":company_id/edit" element={ <Pages.CompanyEdit /> } />
            <Route path=":company_id/offers" element={ <Pages.OfferingsList /> } />
            <Route path=":company_id/offers/:offer_id" element={ <Pages.OfferView /> } />
            <Route path=":company_id/offers/:offer_id/edit/*" element={ <PageAsModal><Pages.OfferEdit /></PageAsModal> } />
            <Route path=":company_id/offers/:offer_id/updates/:update_id/edit" element={ <PageAsModal><Pages.OfferUpdateEditor /></PageAsModal>} />
            <Route path=":company_id/offers/:offer_id/updates/new" element={ <PageAsModal><Pages.OfferUpdateEditor /></PageAsModal>} />
            <Route path=":company_id/offers/:offer_id/live-events/:event_id/edit" element={ <PageAsModal><Pages.LiveEventEditor /></PageAsModal>} />
            <Route path=":company_id/offers/:offer_id/live-events/new" element={ <PageAsModal><Pages.LiveEventEditor /></PageAsModal>} />
            <Route path=":company_id/offers/prelaunch/:preoffer_id" element={ <Pages.PreofferView /> } />
            <Route path=":company_id/offers/prelaunch/:preoffer_id/edit/*" element={ <Pages.PreofferEdit /> } />
            <Route path=":company_id/investors" element={ <Pages.InvestorsList /> } />
            <Route path=":company_id/accounts" element={ <Pages.AccountsList /> } />
          </Route>
        </Route>
        <Route path="logout" element={ <Pages.Logout /> } />
        <Route path="*" element={ <Pages.NotFound /> } />
      </Routes>
      {
        state?.backgroundLocation && 
          (
            <Routes>
              <Route path="companies" element={ <CompanyContextProvider><Outlet /></CompanyContextProvider> }>
                <Route
                  path=":company_id/edit"
                  element={ <PageAsModal><Pages.CompanyEdit /></PageAsModal>}
                />
                <Route
                  path=":company_id/offers/:offer_id"
                  element={ <PageAsModal><Pages.OfferView /></PageAsModal> }
                />
                <Route
                  path=":company_id/offers/:offer_id/edit/*"
                  element={ <PageAsModal><Pages.OfferEdit /></PageAsModal> }
                />
                <Route
                  path=":company_id/offers/prelaunch/:preoffer_id"
                  element={ <PageAsModal><Pages.PreofferView /></PageAsModal> }
                />
                <Route
                  path=":company_id/offers/prelaunch/:preoffer_id/edit/*"
                  element={ <PageAsModal><Pages.PreofferEdit /></PageAsModal> }
                />
                <Route
                  path=":company_id/offers/:offer_id/updates/:update_id/edit"
                  element={ <PageAsModal><Pages.OfferUpdateEditor /></PageAsModal>}
                />
                <Route
                  path=":company_id/offers/:offer_id/updates/new"
                  element={ <PageAsModal><Pages.OfferUpdateEditor /></PageAsModal>}
                />
                <Route
                  path=":company_id/offers/:offer_id/live-events/:event_id/edit"
                  element={ <PageAsModal><Pages.LiveEventEditor /></PageAsModal>}
                />
                <Route
                  path=":company_id/offers/:offer_id/live-events/new"
                  element={ <PageAsModal><Pages.LiveEventEditor /></PageAsModal>}
                />
              </Route>
            </Routes>
          )
      }
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
      <ToastContainer />
      </SessionProvider>
      </PortalizedModalProvider>
    </QueryClientProvider>
  );
}

export default App;
